import { DateTime } from 'luxon';

export function dateStringTo24HourEST(dateString) {
  const dateObject = new Date(dateString);
  const dateTime = DateTime.fromJSDate(dateObject)
    .setZone('America/New_York')
    .toFormat('HH:mm:ss');
  return dateTime;
}
